import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { PageComponent } from '../page/page.component';

@Component({
  selector: 'app-partners-page',
  standalone: true,
  imports: [CommonModule, RouterModule, PageComponent, HeaderComponent],
  templateUrl: './partners-page.component.html',
  styleUrls: ['./partners-page.component.scss']
})
export class PartnersPageComponent implements OnInit, OnDestroy {
  private observer?: IntersectionObserver;
  private readonly ANIMATION_DELAY = 150;
  private readonly OBSERVER_DELAY = 200;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.setupScrollAnimations();
    }
  }

  ngOnDestroy(): void {
    this.cleanup();
  }

  private setupScrollAnimations(): void {
    if (typeof IntersectionObserver === 'undefined') {
      console.warn('IntersectionObserver is not supported in this environment');
      return;
    }

    const observerOptions: IntersectionObserverInit = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };

    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), observerOptions);

    // Use requestAnimationFrame for better performance
    requestAnimationFrame(() => {
      this.observeCards();
    });
  }

  private handleIntersection(entries: IntersectionObserverEntry[]): void {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        // Use requestAnimationFrame for smoother animations
        requestAnimationFrame(() => {
          setTimeout(() => {
            entry.target.classList.add('animate-in');
          }, index * this.ANIMATION_DELAY);
        });
        
        // Stop observing once animated
        this.observer?.unobserve(entry.target);
      }
    });
  }

  private observeCards(): void {
    const cards = document.querySelectorAll('.partner-card');
    cards.forEach(card => {
      card.classList.remove('animate-in');
      this.observer?.observe(card);
    });
  }

  private cleanup(): void {
    this.observer?.disconnect();
  }
}

